<template>
  <div 
        class="item-contents"
        :style="{
            backgroundColor: `${item.statusBag.reservedStatus.backgroundColor}`,
       }" >
      
    <div
        class="item-content"
    >
      <div
        class="room_title"
        :style="{
          color: `${item.statusBag.reservedStatus.color}`,
        }"
      >
        <span>{{ item.name }}</span>
        <span class="gray">{{
          item.floor_info ? item.floor_info.layer_description : ""
        }}</span>
      </div>
      <div
        class="room_state"
        :style="{
          color: `${item.statusBag.reservedStatus.color}`,
        }"
      >
        <span>{{ item.statusBag.nextTitle }}</span>
        <span class="gray">{{ item.statusBag.nextText }}</span>
      </div>
      <div class="room_size">
        <span>
          <img :src="capacityIcon" alt="" />
          <span>{{ item.size }}人</span>
        </span>
        <span class="gary">{{
          item.occupancy_state === "occupancy_occupied" ? "有人" : "无人"
        }}</span>
      </div>
    </div>
    <div class="item-footer">
      <div
        v-for="(t3, i3) in item.reservations"
        :key="i3"
        class="reservations"
        :style="{
          left: `${t3.start_block * 100}%`,
          width: `${(t3.end_block - t3.start_block) * 100}%`,
          backgroundColor: t3.bgColor,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import capacityIcon from "../../../static/img/person.png";

export default {
  name: "MeetingItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      capacityIcon,
    };
  },
};
</script>
<style scoped lang="less">
.gray{
  color:rgba(255, 255, 255, 0.5);
}
.item-contents{
  // border: 1px solid #18FEFE;
  width: 97%;
  margin: 0 auto;
  // height: 110px;
  padding-bottom: 10px;


}
/*border-top: 1px solid #FFFFFF;*/
/*border-bottom: 1px solid #FFFFFF;*/
.item-content {
  display: flex;
  height: calc(100% - 6px);
  width:100%;
  // box-sizing: border-box;
  // margin-left: 15px;
  justify-content: center;
  > div {
    padding: 15px 0 15px 15px;
  }
  .room_title {
    width: calc(40% - 40px);
    font-size: 18px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    span {
      height: 20px;
    }
    span:nth-of-type(1) {
      font-size: 18px;
      font-weight: bold;
      padding-bottom: 6px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    span:nth-of-type(2) {
      font-size: 14px;
      font-weight: 400;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .room_state {
    width: calc(50% - 40px);
    font-size: 18px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // align-items: center;
    // padding-left: 40px;
    height: 100%;
    // margin: 0 auto;
    span {
      height: 20px;
    }
    span:nth-of-type(1) {
      font-size: 18px;
      font-weight: bold;
      padding-bottom: 6px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    span:nth-of-type(2) {
      font-size: 14px;
      font-weight: 400;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .room_size {
    width: calc(10% + 15px);
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    span {
      height: 20px;
    }
    span:nth-of-type(1) {
      padding-bottom: 6px;
      img {
        width: 24px;
        height: 24px;
        position: relative;
        top: 2px;
      }
      span {
        font-weight: 400;
        font-size: 22px;
        margin: auto 0;
        color: #fff;
        display: inline-block;
        margin-left: 6px;
        font-family: 'Alibaba PuHuiTi';
      }
    }

    span:nth-of-type(2) {
      font-size: 14px;
      font-weight: 400;
    }
  }
}
.item-footer {
  height: 6px;
  background-color: rgba(255, 255, 255, 0.08);
  display: flex;
  position: relative;
  width: 95%;
  // left: 35px;
  border-radius: 30px;
  margin: 0 auto;
  .block-item {
    height: 100%;
  }
  .reservations {
    position: absolute;
    top: 0;
    height: 100%;
    border-radius: 20px ;



  }
}
</style>
